import React from 'react'
import styles from './MicrositeSystemBadge.module.css'
import { Lock } from 'lucide-react'

/**
 * MicrositeSystemBadge
 * Marks an item (typically an email template) as a system default
 * that can't be deleted, only edited.
 *
 * Usage:
 *   <MicrositeSystemBadge />
 */
const MicrositeSystemBadge = () => (
    <span className={styles.badge}>
        <Lock size={10} />
        System
    </span>
)

export default MicrositeSystemBadge